"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17.709 20.263H6.291a2.557 2.557 0 0 1-2.554-2.554V6.291a2.557 2.557 0 0 1 2.554-2.554h11.418a2.557 2.557 0 0 1 2.554 2.554v11.418a2.557 2.557 0 0 1-2.554 2.554M6.291 4.768a1.524 1.524 0 0 0-1.523 1.523v11.418a1.524 1.524 0 0 0 1.523 1.523h11.418a1.524 1.524 0 0 0 1.523-1.523V6.291a1.524 1.524 0 0 0-1.523-1.523z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M16.528 12.483H7.475a.515.515 0 1 1 0-1.03h9.053a.515.515 0 1 1 0 1.03"
  })]
}), 'CheckboxIndeterminate');
//# sourceMappingURL=index.js.map